import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useSubmitDialog = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.ISubmitDialogRequestData) =>
        await send<Types.ISubmitDialogRequestData>({
            ID: 35931,
            responses: [35932],
            description: 'Submit Dialog',
            ...request
        }), [send]);
};
